import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangSwitcherComponent } from './lang-switcher/lang-switcher.component';
import { NavComponent } from '@app/core/nav/nav.component';
import { SharedModule } from '@app/shared/modules/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [NavComponent],
  declarations: [LangSwitcherComponent, NavComponent]
})
export class NavModule { }
